<template>
<div class="ccpay-supmetdetail">
         <div class="ccpay-supmetdetail-header">
                <span @click="back"> 退後</span>
                <span >法币補充</span>
                <span></span>
         </div>
         <div class="ccpay-supmetdetail-connect">
            <ul style="background:white">
                <li class="ccpay-supmetdetail-type">
                    <div class="selectTime" @click="selectData">
                    <span >选择時間：</span>
                    <span>{{this.selectedValue}}</span>
                    </div>
                </li>
                 <li class="ccpay-supmetdetail-type">
                  <input class="phoneNum phoneNumTull-lv app-Recharge-number" v-model="price" v-on:input="blurbumber"   placeholder="補充金额" type="number" 
                 ></input>
               
                </li>
                 <li class="ccpay-supmetdetail-type">
                 <input class="phoneNum phoneNumTull-lv app-Recharge-number" v-model="fee" v-on:input="blurfee"  placeholder="手续费" type="number" 
                 ></input>
                
                </li>
                  
                <li>
                    <div class="ccpay-add-img">
                        <p class="sup-tec" style="font-size: 16px;">截图</p>
                        <CloudflareR2Upload
                            :folderPrefix="'fund/legal_currency/'"
                            :acceptTypes="'*.png;*.jpeg;*.jpg;*.gif'"
                            :maxFileSize="5000"
                            @upload-start="handleUploadStart"
                            @upload-success="handleUploadSuccess"
                            @upload-error="handleUploadError"
                            @upload-remove="handleUploadRemove"
                        />
                    </div>
                </li> 
               
                 <li>
                  <mt-field class="phoneNum phoneNumTull-lv"  
                   placeholder="备注" 
                    v-model="remark"
                    ></mt-field>
                </li>
           
              <li >
                    <mt-button class="mt-40" size="large" type="primary" 
                        @click="submit()">補充</mt-button>
                </li>
                 </ul>
         </div>
    
  <div class="pickerDemo">
       <!-- <div class="showTime">
            <p class="timeDes">當前時間是：{{this.selectedValue}}</p>
            <div class="selectTime" @click="selectData">选择時間</div>
        </div>-->
        <!-- @touchmove.prevent 阻止默认事件，此方法可以在选择時間时阻止页面也跟着滚动。 -->
        <div class="pickerPop" @touchmove.prevent>
            <!-- 年月日时分选择 -->
            <mt-datetime-picker
                lockScroll="true"
                ref="datePicker"
                v-model="dateVal"
                class="myPicker"
                type="datetime"
                year-format="{value}"
                month-format="{value}"
                date-format="{value}"
                hour-format="{value}"
                minute-format="{value}"
                second-format="{value}"
                @confirm="dateConfirm()">
            </mt-datetime-picker>
        </div>
    </div>
    </div>
</template>
 
<script>
import { Indicator } from 'mint-ui';
import moment from "moment"
import Vue from 'vue'
import CloudflareR2Upload from '../CloudflareR2Upload.vue'
export default {
    name: 'pickerDemo',
    components: {
        CloudflareR2Upload
    },
    data () {
        return {
            dateVal: '', // 默认是當前日期
            selectedValue: '',
            fund_id:'',//id
            type:'',//类型
            price:'',//均价
            fee:'',//费率
            remark:'',//補充
            typeList:[
                {id:1,name:'对冲'},
                {id:2,name:'借调'},
                {id:3,name:'出入金'},
            ],
            selected:'',
            uploadedFileUrl:'' // 存储上传成功的文件URL
        }
    },
    components: {
    },
    created () {
    },
    mounted () {
        let that = this
        this.fund_id= this.$route.query.fund_id
        
    },
    methods: {
        selectData () { // 打开時間选择器
            // 如果已经选过日期，则再次打开時間选择器时，日期回显（不需要回显的话可以去掉 这个判断）
            if (this.selectedValue) {
                this.dateVal = this.selectedValue
            } else {
                this.dateVal = new Date()
            }
            this.$refs['datePicker'].open()
        },
        dateConfirm () { // 時間选择器确定按钮，并把時間转换成我们需要的時間格式
            this.selectedValue = moment(this.dateVal).format("YYYY-MM-DD HH:SS")
        },
        getTypeSelected(){
            // this.selected = this.selected
            // console.log(this.selected)
        },
        blurbumber(){
            if(this.price==''){
                this.price = ''
                return
            }
            
            if(this.price<0){
                
                let absprice = -(this.price)
                this.price = '-' + absprice.toString().match(/^\d+(?:\.\d{0,2})?/)[0]
               
               
            }else{
                 let absprice = -(this.price)
                if(absprice=='0'){
                    this.price = 0 
                }else{
                    this.price = this.price.toString().match(/^\d+(?:\.\d{0,2})?/)[0]
                }
               
            }
           
            //  console.log(this.price)
        },
        blurfee(){
            if(this.fee==''){
                this.fee = ''
                return
            }
             if(this.fee<=0){
                this.fee = 0
            }
             let a= this.fee.toString().match(/^\d+(?:\.\d{0,2})?/)[0]
             this.fee =  a
            //  console.log(this.fee)
        },
        back(){
            this.$router.go(-1)
        },
        submit(){
           
            if(this.price==''){
                this.$Toast('请输入均价')
                return
            }
            if(this.fee==''){
                this.$Toast('请输入手续费')
                return
            }
            if(this.remark==''){
                this.$Toast('请填写备注')
                return
            }
            if(this.uploadedFileUrl==''){
                this.otosubmit()
            }else{
                this.otosubmit()
            }
           
        },
        otosubmit(){
            Indicator.open();
             
             this.$axios.post('/v1/traders_profit/legal_fund_ex_info/append',{
                "legal_currency": "CNY",
                "amount": this.price,
                "fee": this.fee,
                "img": this.uploadedFileUrl,
                "time": this.selectedValue,
                "remark": this.remark
            }).then(res=>{
                Indicator.close();
                if(res.code==0){
                    this.$router.go(-1)
                     this.$Toast(res.msg)
                }else{
                     this.$Toast(res.msg)
                }
            })
        },
        // 新组件事件处理方法
        handleUploadStart() {
            console.log('开始上传文件...')
        },
        
        handleUploadSuccess(fileUrl) {
            this.uploadedFileUrl = fileUrl
            this.$Toast('文件上传成功')
            console.log('文件上传成功:', fileUrl)
        },
        
                 handleUploadError(error) {
             this.$Toast('文件上传失败: ' + error.message)
             console.error('文件上传失败:', error)
         },
         
         handleUploadRemove() {
             this.uploadedFileUrl = ''
             console.log('文件已删除')
         },
    }
}
</script>
 
<style scoped lang="scss">
.pickerDemo {
    width: 100%;
    height: 18rem;
    
    .showTime {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 2rem;
        
        .timeDes {
            font-size: 0.4rem;
            color: red;
        }
        
        .selectTime {
            display: inline-block;
            width: 4rem;
            height: 1rem;
            line-height: 1rem;
            text-align: center;
            background-color: #ff776d;
            color: #fff;
            font-size: 0.24rem;
            border-radius: 8px;
            margin-top: 1rem;
        }
    }
}

.pickerPop {
    ::v-deep .picker {
        .picker-toolbar {
            background-color: #eee;
            
            .mint-datetime-action {
                font-size: 0.26rem;
                color: #000 !important;
            }
        }
    }
}

.ccpay-supmetdetail {
    height: 100%;
    background: #f8f8f8;
    
    .ccpay-supmetdetail-type {
        position: relative;
        padding: 0 10px;
        color: #666;
        font-size: 0.93rem;
        border-bottom: 1px solid;
        border-color: #eee;
        background: white;
        height: 3rem;
        line-height: 3rem;
        
        select {
            height: 30px;
            border: none;
            background: white;
            width: 50%;
            outline: none;
        }
    }
    
    .sup-tec {
        color: #888;
        text-align: center;
        line-height: 3rem;
    }
    
    .ccpay-supmetdetail-header {
        height: 3rem;
        line-height: 3rem;
        width: 100%;
        position: fixed;
        background: white;
        display: flex;
        justify-content: space-between;
        
        span:nth-of-type(1) {
            margin-left: 1rem;
        }
        
        span:nth-of-type(3) {
            margin-right: 1rem;
        }
    }
    
    .ccpay-supmetdetail-connect {
        padding-top: 4rem;
        padding-left: 1rem;
        padding-right: 1rem;
    }
    
    .ccpay-add-img {
        margin-bottom: 2rem;
        text-align: center;
    }
}

.ccpay-resadd-img {
    margin-bottom: 1rem;
    display: flex;
    justify-content: center;
    
    button {
        background: #ccc;
        padding: 6px;
        outline: none;
        border: none;
        color: white;
    }
}

.app-Recharge-number {
    font-size: 16px;
    font-weight: 400 !important;
    font-family: inherit;
    line-height: 2.3rem !important;
    outline: none;
    padding: 0 10px;
    width: 95%;
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/my/Frenchhistorydetail.vue